<div class="full-height layout-column overflow-x-auto-only">

  <div class="flex layout-column bringoz-table">

    <div class="tr layout-row layout-align-start-center" id="header">
      <div class="th flex">
        <span translate>Team Name</span>
      </div>
      <div class="th flex">
        <span translate>External ID</span>
      </div>
<!--      <div class="th flex" translate>Admin</div>-->
<!--      <div class="th flex" translate>Agents</div>-->
      <div class="th flex" translate>Description</div>
      <div class="th flex">
        <span translate>Created At</span>
      </div>
      <div class="th flex" translate>Updated At</div>
      <div class="th flex-5"></div>
    </div>

    <div class="full-height flex layout-column">
      <cdk-virtual-scroll-viewport itemSize="60" class="flex viewport" (scroll)="getNextBatch()">
        <app-teams-table-row *cdkVirtualFor="let team of teams"
                             class="item"
                             [team]="team"
                             [allowEdit]="allowEdit"
                             [allowDelete]="allowDelete"
                             (editTeamEvent)="editTeamEvent.emit($event)"
                             (deleteTeamEvent)="deleteTeamEvent.emit($event)">
        </app-teams-table-row>
      </cdk-virtual-scroll-viewport>
    </div>

  </div>

</div>

